module.exports = __webpack_public_path__ + "static/media/login-with-facebook-big.4e61b3ef.png";